import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import * as Styled from './FieldHeading.style';
import { markdownComponents } from '../../utils/markdownComponents';

/**
 * Common heading component for form fields
 * Renders label and optional description with markdown support
 * @param {object} props - Component props
 * @param {string} [props.label] - Field label text
 * @param {string} [props.labelId] - ID for the label element (for accessibility)
 * @param {boolean} [props.required=false] - Whether field is required
 * @param {string} [props.description] - Field description (supports markdown)
 * @returns {import('react').ReactElement|null} The field heading component or null if no label/description
 */
function FieldHeading({ label, labelId, required = false, description }) {
  if (!label && !description) {
    return null;
  }

  return (
    <>
      {label && (
        <Styled.FieldLabel
          component="legend"
          id={labelId}
          required={required}
          size="xl"
          weight="600"
        >
          {label}
        </Styled.FieldLabel>
      )}

      {description && (
        <ReactMarkdown components={markdownComponents} rehypePlugins={[rehypeRaw]}>
          {description}
        </ReactMarkdown>
      )}
    </>
  );
}

FieldHeading.propTypes = {
  label: PropTypes.string,
  labelId: PropTypes.string,
  required: PropTypes.bool,
  description: PropTypes.string
};

export default FieldHeading;
